import React from 'react';
import CountReport from '../reports/CountReport';
import AdminAuditLog from '../AdminAuditLog';

/*
  The four reports, and which screen draws each.

  **Rebuilt 6 September 2026 to Group F's approved drawings.** Three of the four
  used to be `AdminExport.jsx`, one screen with one word changed, and none of
  them reported anything: you chose filters, pressed Export CSV, and a file
  downloaded. There was no table, no total and no count of matching rows. The
  owner chose the shape that shows the rows, and `reports/CountReport.jsx` is
  that shape serving all three.

  **Each report now publishes its own page bar**, because the filters belong in
  the bar (rule 26) and each report owns its own. Nothing here draws one, which
  is why the Audit Log's special case is gone: two page bars used to portal into
  the same slot and stack two control rows, and there is only ever one now.

  **The glass panel that used to wrap the page is gone too.** A report is a strip
  of numbers and a list of rows, both of which are white cards with their own
  edges, and rule 6 does not put a card inside a card.
*/
export const REPORTS = [
  { key: 'count_history', label: 'Count History',
    description: 'Full count results for the cycles and places you pick.',
    icon: <><rect x="5" y="4" width="14" height="17" rx="2" /><path d="M9 4V2h6v2" /><path d="M9 10h6M9 14h6M9 18h3" /></> },
  { key: 'non_inventory', label: 'Non-Inventory Items',
    description: 'Items flagged as specialty, custom ordered, or inherited.',
    icon: <><path d="M20.5 7.3 12 12l-8.5-4.7" /><path d="M12 12v9.5" /><path d="M3.5 7.3 12 2.5l8.5 4.8v9.4L12 21.5l-8.5-4.8z" /></> },
  { key: 'dead_stock', label: 'Dead Stock Items',
    description: 'Items flagged as dead stock or no longer in use.',
    icon: <><circle cx="12" cy="12" r="9" /><path d="m15 9-6 6M9 9l6 6" /></> },
  { key: 'audit_log', label: 'Audit Log',
    description: 'Who did what, and when.',
    icon: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3.5 2" /></> },
];

export const REPORT_KEYS = REPORTS.map(r => r.key);

export default function ReportsPage({ report }) {
  const current = REPORTS.find(r => r.key === report) || REPORTS[0];
  if (current.key === 'audit_log') return <AdminAuditLog />;
  return <CountReport key={current.key} kind={current.key} />;
}
